import { BaseClient } from 'src/common-services/clients/base-client'
import {
  AMCensusBlock,
  AMCensusBlockByIdRequest,
  AMCensusBlockGroup,
  AMCensusBlockGroupByIdRequest,
  AMCensusBlockGroupsRequest,
  AMCensusBlocksRequest,
  AMZipCode,
  AMZipCodesRequest,
} from 'src/common-services/types/alphamap'

export class ShapesClient extends BaseClient {
  getCensusBlocks(request: AMCensusBlocksRequest): Promise<AMCensusBlock[]> {
    return this.call<AMCensusBlock[]>(`/v2/shapes/census-blocks`, 'POST', {
      data: request,
    })
  }

  getCensusBlockById(request: AMCensusBlockByIdRequest): Promise<AMCensusBlock | undefined> {
    return this.call<AMCensusBlock | undefined>(`/v2/shapes/census-block/${request.id}`, 'GET')
  }

  getCensusBlockGroups(request: AMCensusBlockGroupsRequest): Promise<AMCensusBlockGroup[]> {
    return this.call<AMCensusBlockGroup[]>(`/v2/shapes/census-block-groups`, 'POST', {
      data: request,
    })
  }

  getCensusBlockGroupById(request: AMCensusBlockGroupByIdRequest): Promise<AMCensusBlockGroup | undefined> {
    return this.call<AMCensusBlockGroup | undefined>(`/v2/shapes/census-block-group/${request.id}`, 'GET')
  }

  getZipCodes(request: AMZipCodesRequest): Promise<AMZipCode[]> {
    return this.call<AMCensusBlockGroup[]>(`/v2/shapes/zip-codes`, 'POST', {
      data: request,
    })
  }

  getH3s(request: AMZipCodesRequest): Promise<string[]> {
    return this.call<string[]>(`/v2/shapes/h3s`, 'POST', {
      data: request,
    })
  }
}
